import { render } from "./PhoneCallCard.vue?vue&type=template&id=f3fbae1a&scoped=true"
import script from "./PhoneCallCard.vue?vue&type=script&lang=js"
export * from "./PhoneCallCard.vue?vue&type=script&lang=js"

import "./PhoneCallCard.vue?vue&type=style&index=0&id=f3fbae1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fbae1a"]])

export default __exports__